import { render, staticRenderFns } from "./message_detail.vue?vue&type=template&id=02c0c320&scoped=true"
import script from "./message_detail.vue?vue&type=script&lang=js"
export * from "./message_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0c320",
  null
  
)

export default component.exports